import { init } from "@sentry/nextjs";
import { getEnvironmentName } from "./app/_common/lib/edgeUtils";

const isDevelopment = getEnvironmentName() === "development";

export const sentryDefaults: Parameters<typeof init>[0] = {
  dsn: isDevelopment ? undefined : process.env.SENTRY_DSN,
  release:
    (process.env.GIT_BRANCH || process.env.RENDER_GIT_BRANCH) === "production"
      ? process.env.GIT_COMMIT || process.env.RENDER_GIT_COMMIT
      : undefined,
  sampleRate: 1,
  tracesSampleRate: 0,
  environment: getEnvironmentName(),
  sendDefaultPii: true,
  maxBreadcrumbs: 50,
};
